import axios from 'axios';

// fixme заменить axios на axiosBeelineRequest import { axiosBeelineRequest } from "@beef/utils";
import { requestConfig } from "../constants";
function getHousesForStreet(streetId, term) {
  var fiasId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return axios.post('/checkconnection/GetHouses/', {
    streetId: streetId,
    term: term,
    fiasId: fiasId
  }, requestConfig);
}
export default getHousesForStreet;